import React from 'react';
import { Col, Row } from 'react-bootstrap';

import ReadMore from '../../components/ReadMore';
import brokersTechnologyChampions from '../../../assets/images/brokersTechnologyChampions.jpg';

const BrokersTechnologyChampions = ({ isMobile }) => {

  return (
    <Col>
      <Row>
        <Col>
          <h2
            id="brokers-technology-champions"
            tabIndex="-1"
          >
            BROKERS' TECHNOLOGY CHAMPIONS
          </h2>
        </Col>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col xs={12} md={6} lg={4} style={{
          paddingTop: 20,
          paddingLeft: 20,
          paddingRight: 20
        }}>
          <div style={{
            backgroundImage: `url(${brokersTechnologyChampions})`,
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            width: '100%',
            height: '100%'
          }} />
        </Col>
        <Col xs={12} md={6} lg={8}>
          <p>
            As our industry changes, nobody can afford to lag behind in technology.
          </p>
          <p>
            CSIO brings the industry together to create technology solutions with a purpose. Together, we create solutions that members couldn't develop alone.
          </p>
          <p>
            Whether it's adopting new technology to smooth operations, meeting changing customer demands or understanding cybersecurity, CSIO is the champion for brokers' technology interests. And like technology, our programs and solutions never stop evolving.
          </p>
        </Col>
      </Row>
      <Row style={{ marginTop: 30 }}>
        <Col>
          <ReadMore href="/brokers-technology-champions#top" />
        </Col>
      </Row>
    </Col>
  )
}

export default BrokersTechnologyChampions;
